import { useState, useEffect } from 'react';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-black shadow-lg' : 'bg-black'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center space-x-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <div className="w-14 h-14 flex items-center justify-center">
              <img 
                src="https://static.readdy.ai/image/096be9c57cd562040b50de9c711536fc/281fbea3ff24195271af1eb3bd4da899.jpeg"
                alt="Mow and Snow Logo"
                className="w-full h-full object-contain"
              />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-white transition-colors">
                Mow and Snow
              </h1>
              <p className="text-xs text-white/90 transition-colors">
                All-Season Landscaping
              </p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {['Home', 'About', 'Services', 'Pricing', 'Service Areas', 'Contact'].map((item) => (
              <button
                key={item}
                onClick={() => scrollToSection(item.toLowerCase().replace(' ', '-'))}
                className="font-medium text-white transition-colors hover:text-yellow-400 whitespace-nowrap"
              >
                {item}
              </button>
            ))}
          </nav>

          {/* Phone Number */}
          <a
            href="tel:+16479837924"
            className="hidden lg:flex items-center space-x-2 px-6 py-3 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer bg-gradient-to-r from-yellow-400 to-yellow-500 text-gray-900 hover:from-yellow-500 hover:to-yellow-600"
          >
            <i className="ri-phone-line text-lg"></i>
            <span>(647) 983-7924</span>
          </a>

          <a
            href="mailto:info@mowandsnow.co"
            className="hidden lg:flex items-center space-x-2 text-white/90 hover:text-yellow-400 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-mail-line"></i>
            <span className="text-sm">info@mowandsnow.co</span>
          </a>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 rounded-lg transition-colors text-white hover:bg-white/10"
          >
            <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-black shadow-lg border-t border-white/10">
          <nav className="px-4 py-6 space-y-4">
            {['Home', 'About', 'Services', 'Pricing', 'Service Areas', 'Contact'].map((item) => (
              <button
                key={item}
                onClick={() => scrollToSection(item.toLowerCase().replace(' ', '-'))}
                className="block w-full text-left px-4 py-3 text-white font-medium hover:bg-yellow-400/10 hover:text-yellow-400 rounded-lg transition-colors whitespace-nowrap"
              >
                {item}
              </button>
            ))}
            <a
              href="tel:+16479837924"
              className="flex items-center justify-center space-x-2 px-6 py-3 bg-gradient-to-r from-yellow-400 to-yellow-500 text-gray-900 rounded-lg font-semibold hover:from-yellow-500 hover:to-yellow-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line text-lg"></i>
              <span>(647) 983-7924</span>
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
